/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Organisation1Inputs */

const en_coinvestments_insights_col_organisation1 = /** @type {(inputs: Coinvestments_Insights_Col_Organisation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "Organisation" |
*
* @param {Coinvestments_Insights_Col_Organisation1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_organisation1 = /** @type {((inputs?: Coinvestments_Insights_Col_Organisation1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Organisation1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_organisation1(inputs)
});
export { coinvestments_insights_col_organisation1 as "coInvestments_insights_col_organisation" }